// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_kyz","cls2":"download_preflight-cls2_W0p download_preflight-cls1_kyz"};